import { render, staticRenderFns } from "./SiteNavSubMenuItem.vue?vue&type=template&id=10305651&scoped=true&lang=pug&"
import script from "./SiteNavSubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SiteNavSubMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10305651",
  null
  
)

export default component.exports